module.exports = __webpack_public_path__ + "static/img/14000075.64130e0f.png";